var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"385137068ceca592bc9fc91c63f92194958bdbad"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["purple-start-web-app@purple-start"]={id:"385137068ceca592bc9fc91c63f92194958bdbad"};
      